import { head } from 'ramda'

import { hasValue } from '../../../../../../utils/helpers/value'
import { logAndReturn } from '../../../../../../utils/helpers/log'

export const changeCronValue = (cron, field, value) => {
  let { hour, minute, day_of_month, day_of_week } = cron || {}

  hour = hasValue(hour?.values) ? head(hour?.values) : '*'
  minute = hasValue(minute?.values) ? head(minute?.values) : '*'
  let dayOfMonth = hasValue(day_of_month?.values) ? day_of_month?.values.join(',') : '*'
  let month = '*'
  let dayOfWeek = hasValue(day_of_week?.values) ? day_of_week?.values.join(',') : '*'

  switch (field) {
    case 'time':
      hour = value?.hour
      minute = value?.minute
      break

    case 'dayOfMonth':
      dayOfMonth = value
      dayOfWeek = '*'
      break

    case 'dayOfWeek':
      dayOfWeek = value
      dayOfMonth = '*'
      break
  }

  return logAndReturn(`${minute} ${hour} ${dayOfMonth} ${month} ${dayOfWeek}`)
}
